import { fontFamilies } from "./fontFamilies";
import { textPositions } from "./textPositions";

export const presets = [
  {
    colorScheme: 3,
    quad1: {
      color: "color1",
      shape: "triangle",
      rotation: 0,
    },
    quad2: {
      color: "color2",
      shape: "square",
      rotation: 0,
    },
    quad3: {
      color: "color5",
      shape: "square",
      rotation: 0,
    },
    quad4: {
      color: "color4",
      shape: "triangle",
      rotation: 0,
    },
    animation: 'animateXY',
    xCols: [36, 20, 10, 34],
    yRows: [30, 30, 30, 10],
    textTop: "SUPERMARKET",
    textBottom: "WE'RE NOT SQUARE",
    textColor: "color4",
    textBGColor: "color8",
    textBGActive: false,
    fontFamily: fontFamilies[0],
    textPosition: textPositions[0],
    background: "color8",
    repetition: "repeat",
  },
  {
    colorScheme: 2,
    quad1: {
      color: "color6",
      shape: "quarterCircle",
      rotation: 180,
    },
    quad2: {
      color: "color5",
      shape: "quarterCircle",
      rotation: 270,
    },
    quad3: {
      color: "color4",
      shape: "quarterCircle",
      rotation: 0,
    },
    quad4: {
      color: "color4",
      shape: "quarterCircle",
      rotation: 90,
    },
    animation: 'noAnimation',
    xCols: [20, 20, 40, 20],
    yRows: [20, 20, 40, 20],
    textTop: "SUPERMARKET",
    textBottom: "Hue & Cry Tributes",
    textColor: "color4",
    textBGColor: "color6",
    textBGActive: false,
    fontFamily: fontFamilies[1],
    textPosition: textPositions[0],
    background: "color3",
    repetition: "mirrorTwo",
    hiddenRepetitions: ['11', '12', '21', '22'],
  },
  {
    colorScheme: 0,
    quad1: {
      color: "color5",
      shape: "triangle",
      rotation: 0,
    },
    quad2: {
      color: "color5",
      shape: "quarterCircle",
      rotation: 90,
    },
    quad3: {
      color: "color5",
      shape: "quarterCircle",
      rotation: 180,
    },
    quad4: {
      color: "color5",
      shape: "triangle",
      rotation: 270,
    },
    animation: 'animateX',
    xCols: [25, 25, 25, 25],
    yRows: [25, 25, 25, 25],
    textTop: "SUPERMARKET",
    textBottom: "Matisse Mixtape B-Sides",
    textColor: "color2",
    textBGColor: "color5",
    textBGActive: true,
    fontFamily: fontFamilies[1],
    textPosition: textPositions[1],
    background: "color2",
    repetition: "repeat",
    hiddenRepetitions: ['00', '01', '02', '03'],
  },
  {
    colorScheme: 3,
    quad1: {
      color: "color9",
      shape: "quarterCircle",
      rotation: 180,
    },
    quad2: {
      color: "color9",
      shape: "triangle",
      rotation: 0,
    },
    quad3: {
      color: "color9",
      shape: "triangle",
      rotation: 0,
    },
    quad4: {
      color: "color9",
      shape: "reverseQuarterCircle",
      rotation: 0,
    },
    animation: 'animateXY',
    xCols: [3, 7, 58, 32],
    yRows: [40, 50, 5, 5],
    textTop: "SUPERMARKET",
    textBottom: "Graphic Struggles Vol. 2",
    textColor: "color6",
    textBGColor: "color8",
    textBGActive: false,
    fontFamily: fontFamilies[2],
    textPosition: textPositions[2],
    background: "color1",
    repetition: "mirrorTwo",
  },
  {
    colorScheme: 6,
    quad1: {
      color: "color3",
      shape: "triangle",
      rotation: 180,
    },
    quad2: {
      color: "color7",
      shape: "triangle",
      rotation: 0,
    },
    quad3: {
      color: "color5",
      shape: "triangle",
      rotation: 0,
    },
    quad4: {
      color: "color6",
      shape: "triangle",
      rotation: 180,
    },
    animation: 'animateY',
    xCols: [9, 27, 46, 18],
    yRows: [17, 33, 40, 10],
    textTop: "SUPERMARKET",
    textBottom: "It's Summer Somewhere",
    textColor: "color7",
    textBGColor: "color3",
    textBGActive: true,
    fontFamily: fontFamilies[2],
    textPosition: textPositions[0],
    background: "color8",
    repetition: "mirror",
  },

  {
    colorScheme: 5,
    quad1: {
      color: "color6",
      shape: "triangle",
      rotation: 0,
    },
    quad2: {
      color: "color2",
      shape: "curvyDiagonal",
      rotation: 90,
    },
    quad3: {
      color: "color6",
      shape: "curvyDiagonal",
      rotation: 180,
    },
    quad4: {
      color: "color2",
      shape: "triangle",
      rotation: 270,
    },
    animation: 'animateX',
    xCols: [5, 13, 17, 65],
    yRows: [15, 65, 15, 5],
    textTop: "",
    textBottom: "",
    textColor: "color2",
    textBGColor: "color8",
    textBGActive: false,
    fontFamily: fontFamilies[2],
    textPosition: textPositions[2],
    background: "color1",
    repetition: "repeat",
  },
];
